import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import { App } from './components/App/App';
import { BrokerSeamPage } from './pages/Broker/BrokerSeamPage';
import { seamPageFor } from './pages/Broker/brokerSeam';
import { UnauthenticatedRoutes } from './components/UnauthenticatedArea/UnauthenticatedRoutes';

// The broker's seam pages are plain paths on this origin rather than routes in
// the portal's hash router: they own the whole document and must not mount the
// portal's auth shell, which would try to start a session they have none for.
const seamPage = seamPageFor(window.location.pathname, window.location.search);

// Bridges the real (non-hash) /workspace URL into the SPA's hash-based workspace selection route.
if (seamPage === null && window.location.pathname.replace(/\/$/, '') === '/workspace') {
  const hashPath = `${UnauthenticatedRoutes.WORKSPACE_SELECTION_ROUTE}${window.location.search}`;
  window.history.replaceState(null, '', `${window.location.origin}/#${hashPath}`);
}

ReactDOM.render(
  seamPage !== null ? (
    <BrokerSeamPage page={seamPage} search={window.location.search} navigate={(url) => window.location.assign(url)} />
  ) : (
    <App />
  ),
  document.getElementById('root')
);
